'use strict';

function CompanyGroupPublicationService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/groups/:groupId/publications/:publicationId', {}, {
    'update': { method: 'PUT' }
  });
}

angular.module('dokiv')
  .factory('CompanyGroupPublicationService', ['$resource', 'config', CompanyGroupPublicationService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/groups/CompanyGroupPublicationService.js
// module id = 359
// module chunks = 0